import { Component } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services';
import { DashboardService } from '../dashboard.service';

@Component({
    selector: 'ms-dashboard-navigation-tabs',
    templateUrl: './dashboard-navigation-tabs.component.html',
    styleUrls: ['./dashboard-navigation-tabs.component.scss'],
    standalone: false
})
export class DashboardNavigationTabsComponent {
  get isStudent() {
    return this._authService.accountType === 'student';
  }

  get canViewRating() {
    return this._userService.user?.canViewRating ?? true;
  }

  // TODO: Временное решение
  get isTeacher() {
    return (
      this._authService.accountType === 'teacher' ||
      this._authService.accountType === 'coach' ||
      this._authService.accountType === 'manager' ||
      this._authService.accountType === 'admin'
    );
  }

  constructor(
    private _authService: AuthService,
    private readonly _dashboardService: DashboardService,
    private readonly _userService: UserService,
  ) {}

  toggleSidebar() {
    this._dashboardService.toggleOverlayOpen();
  }
}
